import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

const DEBOUNCE_MS = 300;

interface TextFilterProps {
  label: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}

// Local draft so typing feels responsive while the URL write is debounced.
export const TextFilter: FC<TextFilterProps> = ({ label, value, onChange }) => {
  const [draft, setDraft] = useState(value ?? '');

  // Follow outside changes: the chip's unset, back button, deep link.
  useEffect(() => {
    setDraft(value ?? '');
  }, [value]);

  useEffect(() => {
    const trimmed = draft.trim();
    if (trimmed === (value ?? '')) {
      return undefined;
    }
    const handle = setTimeout(
      () => onChange(trimmed === '' ? undefined : trimmed),
      DEBOUNCE_MS
    );
    return () => clearTimeout(handle);
  }, [draft, value, onChange]);

  return (
    <TextField
      label={label}
      value={draft}
      onChange={(event) => setDraft(event.target.value)}
      size="small"
      fullWidth
    />
  );
};
